import { connect } from 'react-redux';
import {
    IMAGE_TYPE,
    AMOUNT_OF_PLACEHOLDERS,
    PRODUCT_GALERY_POPUP_ID,
    THUMBNAIL_KEY
} from './ProductGallery.config';

import { ProductGalleryContainer as SourceProductGalleryContainer, mapDispatchToProps, mapStateToProps as SourcemapStateToProps } from 'SourceComponent/ProductGallery/ProductGallery.container';
export const getSortedItems = (unsortedItems) => Array.from(unsortedItems).sort((
    { image_id },
    { image_id: prev_image_id }
) => (image_id - prev_image_id));

export { mapDispatchToProps };

export const mapStateToProps = (state) => ({
    ...SourcemapStateToProps(state),
    isMobile: state.ConfigReducer.device.isMobile
});

export class ProductGalleryContainer extends SourceProductGalleryContainer {

    __construct(props) {
        super.__construct(props);

        const { product: { id } } = props;

        this.state = {
            activeImage: this.getBaseImage(),
            activeGiftCard: this.getGiftImage(),
            isZoomEnabled: false,
            prevProdId: id,
            isImageZoomPopupActive: false
        };
    }

    containerFunctions = {
        onActiveImageChange: this.onActiveImageChange.bind(this),
        onActiveGiftCardChange: this.onActiveGiftCardChange.bind(this),
        handleZoomChange: this.handleZoomChange.bind(this),
        disableZoom: this.disableZoom.bind(this),
        handleImageZoomPopupActiveChange: this.handleImageZoomPopupActiveChange.bind(this)
    };

    containerProps() {
        const { activeImage, activeGiftCard, isZoomEnabled, isImageZoomPopupActive } = this.state;
        let { product: { id, am_giftcard_images }, isMobile, giftCardProps, setGiftOptions, isProductPopup } = this.props;
        if (am_giftcard_images)
            am_giftcard_images = getSortedItems(am_giftcard_images);

        return {
            setGiftOptions,
            giftCardProps,
            gallery: this.getGalleryPictures(),
            productName: this._getProductName(),
            activeImage,
            activeGiftCard,
            isZoomEnabled,
            productId: id,
            am_giftcard_images,
            isMobile,
            isImageZoomPopupActive,
            isProductPopup,
            sliderRef: this.sliderRef
        };
    }


    getGalleryPictures() {
        let {
            areDetailsLoaded,
            product: {
                media_gallery_entries: mediaGallery = [],
                [THUMBNAIL_KEY]: { url: thumbnailUrl } = {},
                [IMAGE_TYPE]: { url: imageTypeUrl } = {},
                name
            }
        } = this.props;

        const url = imageTypeUrl || thumbnailUrl;

        if (mediaGallery.length) {

            mediaGallery = mediaGallery.map((item, index) => ({
                ...item,
                label: `${this._getProductName() + ' ' + item.position}` // Assign a name based on the index of the object in the array
            }));

            return mediaGallery
                .filter(({ disabled }) => !disabled)
                .sort((a, b) => a.position - b.position);
        }

        if (!url) {
            return Array(AMOUNT_OF_PLACEHOLDERS + 1).fill({ media_type: 'placeholder' });
        }

        const placeholders = !areDetailsLoaded
            ? Array(AMOUNT_OF_PLACEHOLDERS).fill({ media_type: 'placeholder' }) : [];

        return [
            {
                thumbnail: { url },
                base: { url },
                id: THUMBNAIL_KEY,
                label: name,
                media_type: IMAGE_TYPE
            },
            ...placeholders
        ];
    }


    onActiveGiftCardChange(activeGiftCard) {
        const {
            product: {
                am_giftcard_code_image: sortSequence = ""
            },
            setGiftOptions
        } = this.props;
        this.setState({
            activeGiftCard: Math.abs(activeGiftCard),
            isZoomEnabled: false
        });
        setGiftOptions({ am_giftcard_image: sortSequence.split(",")[activeGiftCard] })
    }

    componentDidUpdate(prevProps) {
        const { product: { media_gallery_entries: mediaGallery = [] }, isZoomEnabled } = this.props;
        const { product: { media_gallery_entries: prevMediaGallery = [] }, isZoomEnabled: prevZoomEnabled } = prevProps;

        // if (mediaGallery !== prevMediaGallery || isZoomEnabled !== prevZoomEnabled) {
        //     this.onActiveImageChange(this.getBaseImage());
        // }
    }

    getGiftImage() {
        const {
            product: {
                am_giftcard_images: mediaGallery = [],
                am_giftcard_code_image: sortSequence = ""
            }
        } = this.props;

        const position = Number(sortSequence.split(",")[0]) || 0;

        if (mediaGallery.length === 0) {
            return 0;
        }

        const positionsArray = mediaGallery.reduce((acc, item) => {
            const { image_id } = item;

            acc.push(image_id);

            return acc;
        }, []).sort((a, b) => a - b);

        return positionsArray.findIndex((value) => value === position);
    }

    getBaseImage() {
        const {
            product: {
                media_gallery_entries: mediaGallery = []
            }
        } = this.props;

        let baseImage = mediaGallery.find((value) => value.types.includes(IMAGE_TYPE));
        if (!baseImage) {
            baseImage = mediaGallery.find((value) => value.media_type.includes(IMAGE_TYPE));
        }
        const { position = 0 } = baseImage || {};

        if (!mediaGallery.length) {
            return 0;
        }

        const positionsArray = mediaGallery.reduce((acc, item) => {
            const { position } = item;

            acc.push(position);

            return acc;
        }, []).sort((a, b) => a - b);

        return positionsArray.findIndex((value) => value === position);
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(ProductGalleryContainer);
